module.exports = __webpack_public_path__ + "6f2b83c4cc4452e443fb17b7bc04fb6b.png";


//////////////////
// WEBPACK FOOTER
// ./content/help/research/insilico/scoring-img/img2.png
// module id = 1321
// module chunks = 0